import { createContext, useContext } from 'react';

export interface BrandConfig {
  name: string;
  logo?: string;
  logoSquare?: string;
  logoHorizontal?: string;
  colors: {
    primary: string;
    secondary: string;
  };
  documentMeta?: BrandDocumentMeta;
  tenancyEnabled?: boolean;
}

export interface BrandDocumentMeta {
  title?: string;
  description?: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
}

const BrandContext = createContext<BrandConfig | undefined>(undefined);

export const BrandProvider = BrandContext.Provider;

export const useBrand = () => {
  const context = useContext(BrandContext);
  if (!context) {
    throw new Error('useBrand must be used within a <BrandProvider>');
  }
  return context;
};
